import { GanttChart } from 'components';
import { ContainerChangeTime } from 'containers/GranttChart';
import { dayjs } from 'libs';
import { FC, useState } from 'react';

import SectionStyled from './styles';

type Props = {};

const GanttMock: FC<Props> = () => {
  const [typeGroup, setTypeGroup] = useState(true);
  const [currentDate, setCurrentDate] = useState<Date>(dayjs().startOf('month').toDate());
  return (
    <SectionStyled>
      <div className="box-button mt-16 mb-16">
        <div className="">
          <button onClick={() => setTypeGroup(!typeGroup)}>
            {typeGroup ? 'Gantt group' : 'Gantt'}
          </button>
        </div>
      </div>
      <div className="d-flex justify-center flex-column">
        {typeGroup ? (
          <>
            <ContainerChangeTime onChangeDate={setCurrentDate} />
            <GanttChart
              width={'1252px'}
              readonly={false}
              type={typeGroup ? 'group' : 'default'}
              data={dataGanttGroup}
              typeGroup={typeGroup}
              currentDate={currentDate}
            />
          </>
        ) : (
          <>
            <ContainerChangeTime onChangeDate={setCurrentDate} />
            <GanttChart
              width={'1252px'}
              boderDash
              readonly={false}
              scale_height={49}
              type={typeGroup ? 'group' : 'default'}
              typeGroup={typeGroup}
              currentDate={currentDate}
              data={dataGantt}
            />
          </>
        )}
      </div>
    </SectionStyled>
  );
};

const dataGanttGroup = [
  {
    id: 1,
    work_type: '基礎',
    text: '田中工務店',
    start_date: '2021-09-28',
    end_date: '2021-10-15',
    className: 'primary',
    open: true,
    label: '作業員登録済み',
  },
  {
    id: 11,
    work_type: '',
    text: '田中太郎',
    render: 'split',
    className: 'hidden',
    parent: '1',
    label: '',
  },
  {
    id: 111,
    work_type: '',
    text: '田中太郎',
    start_date: '2021-10-02',
    duration: 2,
    className: 'primary',
    parent: '11',
    label: '',
  },
  {
    id: 112,
    work_type: '',
    text: '田中太郎',
    start_date: '2021-10-01',
    duration: 4,
    className: 'primary',
    parent: '11',
    label: '',
  },
  {
    id: 12,
    work_type: '',
    text: '藤 浩太郎',
    start_date: '2021-10-22',
    duration: 10,
    className: 'disable',
    parent: '1',
    label: '',
  },
  {
    id: 13,
    work_type: '',
    text: '綾小路 ひとみ',
    start_date: '2021-10-23',
    duration: 0,
    className: 'primary',
    parent: '1',
    label: '',
  },
  {
    id: 14,
    work_type: '',
    text: '内田 利夫',
    start_date: '2021-10-11',
    duration: 8,
    className: 'primary',
    parent: '1',
    label: '',
  },
  {
    id: 2,
    work_type: 'パネル',
    text: '平山工務店',
    start_date: '2021-10-11',
    duration: 8,
    className: 'disable',
    label: '作業員登録済み',
  },
  {
    id: 21,
    work_type: '',
    text: '田中太郎',
    start_date: '2021-10-02',
    duration: 4,
    className: 'primary',
    parent: '2',
    label: '',
  },
  {
    id: 22,
    work_type: '',
    text: '藤 浩太郎',
    start_date: '2021-10-24',
    duration: 10,
    className: 'disable',
    parent: '2',
    label: '',
  },
  {
    id: 23,
    work_type: '',
    text: '綾小路 ひとみ',
    start_date: '2021-10-25',
    duration: 0,
    className: 'primary',
    parent: '2',
    label: '',
  },
  {
    id: 24,
    work_type: '',
    text: '内田 利夫',
    start_date: '2021-10-11',
    duration: 8,
    className: 'primary',
    parent: '2',
    label: '',
  },
  {
    id: 3,
    work_type: '建方',
    text: '立川工務店',
    start_date: '2021-10-11',
    duration: 8,
    className: 'disable',
    label: '作業員登録なし',
  },
  {
    id: 31,
    work_type: '',
    text: '田中太郎',
    start_date: '2021-10-02',
    duration: 4,
    className: 'primary',
    parent: '3',
    label: '',
  },
  {
    id: 32,
    work_type: '',
    text: '藤 浩太郎',
    start_date: '2021-10-26',
    duration: 10,
    className: 'disable',
    parent: '3',
    label: '',
  },
  {
    id: 33,
    work_type: '',
    text: '綾小路 ひとみ',
    start_date: '2021-10-27',
    duration: 0,
    className: 'primary',
    parent: '3',
    label: '',
  },
  {
    id: 34,
    work_type: '',
    text: '内田 利夫',
    start_date: '2021-09-28',
    end_date: '2021-10-04',
    duration: 8,
    className: 'primary',
    parent: '3',
    label: '',
  },
  {
    id: 4,
    work_type: '造作',
    text: '内田工務店',
    start_date: '2021-09-11',
    end_date: '2021-10-04',
    duration: 8,
    className: 'disable',
    label: '遅延連絡あり',
  },
  {
    id: 41,
    work_type: '',
    text: '田中太郎',
    start_date: '2021-10-02',
    duration: 4,
    className: 'primary',
    parent: '4',
    label: '',
  },
  {
    id: 42,
    work_type: '',
    text: '藤 浩太郎',
    start_date: '2021-10-28',
    duration: 10,
    className: 'disable',
    parent: '4',
    label: '',
  },
  {
    id: 43,
    work_type: '',
    text: '綾小路 ひとみ',
    start_date: '2021-10-29',
    duration: 0,
    className: 'primary',
    parent: '4',
    label: '',
  },
  {
    id: 44,
    work_type: '',
    text: '内田 利夫',
    start_date: '2021-10-11',
    duration: 8,
    className: 'primary',
    parent: '4',
    label: '',
  },
];
const dataGantt = [
  {
    id: 1,
    text: '東京内田中様集合住宅新築工事',
    title_quickinfo: '東京内田中様集合住宅新築工事',
    label_Column: '内装',
    start_date: '2021-9-30',
    end_date: '2021-10-13',
    className: 'primary',
    IsEditable: false,
  },
  {
    id: 2,
    text: '東京佐藤邸住宅新築工事',
    title_quickinfo: '東京佐藤邸住宅新築工事',
    start_date: '2021-10-12',
    end_date: '2021-10-23',
    duration: 4,
    label_Column: '外構',
    className: 'disable',
    IsEditable: false,
  },
  {
    id: 3,
    start_date: '2021-10-27',
    end_date: '2021-11-02',
    duration: 10,
    text: '東京佐藤邸住宅新築工事',
    title_quickinfo: '東京佐藤邸住宅新築工事',
    label_Column: '内装',
    className: 'disable',
    isSeparate: true,
    IsEditable: false,
  },

  {
    id: `${40}`,

    IsEditable: true,
    text: '田中 太郎',
    className: 'primary',
    render: 'split',
    isParent: true,
    operator: '金井 達士',
    label: '東京内田中様集合住宅新築工',
  },
  {
    id: `${41}`,

    IsEditable: true,
    text: '田中 太郎 11',
    start_date: '2021-10-02',
    end_date: '2021-10-13',
    className: 'primary',
    parent: `${40}`,
    locale: '外構',
    operator: '金井 達士',
    label: '東京内田中様集合住宅新築工事 23132',
    label_task: '外構',
  },
  {
    id: 411,
    IsEditable: true,
    text: '',
    parent: '40',
    start_date: '2021-10-17',
    end_date: '2021-10-23',
    isChild: true,
    className: 'disable',
    locale: '内装',
    operator: '金井 達士',
    label: '東京内田中様集合住宅新築工事',
  },
  {
    id: 4111,
    IsEditable: true,
    text: '',
    render: 'split',
    duration: 6,
    isChild: true,
    className: 'disable',
  },
  {
    id: 4112,

    IsEditable: true,
    text: '',
    start_date: '2021-10-09',
    end_date: '2021-10-15',
    operator: '金井 達士',
    label: '東京佐藤邸住宅新築工事',
    locale: '外構',
    parent: '4111',
    className: 'disable',
  },
  {
    id: 4113,

    IsEditable: true,
    text: '',
    start_date: '2021-10-24',
    end_date: '2021-10-28',
    parent: '4111',
    locale: '外構',
    operator: '金井 達士',
    label: '東京佐藤邸住宅新築工',
    className: 'disable',
  },
  {
    id: 4211,

    IsEditable: true,
    text: '',
    render: 'split',
    duration: 6,
    className: 'disable',
  },

  {
    id: 4114,

    IsEditable: true,
    text: '',
    start_date: '2021-10-29',
    end_date: '2021-10-30',
    parent: '4211',
    locale: '内装',
    operator: '金井 達士',
    label: '東京佐藤邸住宅新築工事',
    className: 'disable',
  },

  {
    id: 4115,

    IsEditable: true,
    text: '',
    start_date: '2021-10-14',
    end_date: '2021-10-20',
    parent: '4211',
    locale: '内装',
    operator: '金井 達士',
    label: '東京佐藤邸住宅新築工事',
    className: 'disable',
  },
];
export default GanttMock;
